<div class="nav-item-container flex-start items-center">
  <div #navItem class="nav-item-title align-center items-center">
    <ng-content></ng-content>
  </div>
</div>
